// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"56364432","216":"f920daa1","460":"f08a02d6","547":"fa5f5441","667":"02b29424","834":"fa81532f","941":"7b451aa0"}[chunkId] + ".chunk.css";
};